<template>
  <div class="LKMunMehReviewFourLevels__Documents">
    <template v-if="hasDocs">
      <div
        v-for="(doc, docIdx) in docs"
        :key="`${value.id}.D${docIdx}`"
      >
        <a :href="doc.link" target="_blank" class="link" v-text="doc.link" />
        <div class="comment" v-text="doc.comment" />
      </div>
    </template>
    <div v-else>
      Документы отсутствуют
    </div>
    <div class="updated-at" :class="{ logged: isUpdatedAtVisible }">
      {{ updatedAt | dateFormatter }}
    </div>
  </div>
</template>

<script>
import { LKMunMehReviewMapper } from '@/views/LKMunMeh/Review/store'

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...LKMunMehReviewMapper.mapGetters([
      'getDocuments',
      'isIndicatorInLogs',
    ]),
    hasDocs() {
      return this.docs.length > 0
    },
    isUpdatedAtVisible() {
      return this.isIndicatorInLogs(this.value.id)
    },
    docs() {
      return this.getDocuments(this.value.id)?.data || []
    },
    updatedAt() {
      return this.getDocuments(this.value.id)?.updated_at
    },
  },
}
</script>
